// --- AiroLife custom JS (versione safe + slider escluso) ---

document.addEventListener('DOMContentLoaded', () => {
  console.log('✅ AiroLife custom.js loaded');

  // Scroll dolce per i link interni (#ancore)
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Lazy "smart": tutte le img, MA NON quelle dello slider
  const allImages = document.querySelectorAll('img:not([loading])');
  allImages.forEach((img) => {
    // ⛔ salta le immagini dello slider (sono dentro .image-wrapper)
    if (img.closest('.image-wrapper')) return;
    img.setAttribute('loading', 'lazy');
  });

  // Se in futuro vorrai usare data-lazy="true" per cose speciali:
  const lazyImages = document.querySelectorAll('[data-lazy="true"]');
  if ('IntersectionObserver' in window && lazyImages.length > 0) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          if (el.dataset.src) {
            el.src = el.dataset.src;
          }
          el.dataset.lazy = 'loaded';
          observer.unobserve(el);
        }
      });
    });

    lazyImages.forEach(img => observer.observe(img));
  }
});

